// User
export const POST_LOGIN = "/login";
export const POST_FORGOT_PASSWORD = "/user/forgot-password";
export const POST_PASSWORD_CHANGE = "/user/password";
export const UPDATE_OWN_PASSWORD = "/user/password";
export const GET_OWN_PERSONAL_INFO = "/user/personal-info";
export const UPDATE_OWN_PERSONAL_INFO = "/user/personal-info";
export const UPDATE_OTHER_USER_PERSONAL_INFO = "/user/user-info";
export const GET_COMPANY_USERS = "/users";
export const POST_CREATE_USER = "/user";
export const DELETE_USER = "/users";
// Maintenance
export const GET_CHECK_MAINTENANCE = '/checkMaintenance';
// Permission
export const GET_PERMISSION_LIST = "/permission-list";
export const GET_PERMISSIONS = "/permissions";
export const POST_PERMISSION = "/permission";
export const POST_USER_PERMISSION = "/user-permission";
export const DELETE_PERMISSION = "/permission";
// Language
export const GET_LANGUAGE = "/language/en";
// Company
export const GET_MENUBAR = "/menubar";
export const GET_COMPANY = "/company";
export const UPDATE_COMPANY = "/company";
// Client
export const GET_CLIENTS = "/clients";
export const POST_CLIENT = "/client";
export const DELETE_CLIENT = "/client";
export const UPDATE_CLIENT = "/client";
// Brand
export const GET_BRANDS = "/brands";
export const POST_BRAND = "/brand";
export const DELETE_BRAND = "/brand";
export const UPDATE_BRAND = "/brand";
// Market
export const GET_MARKETS = "/markets";
export const POST_MARKET = "/market";
export const DELETE_MARKET = "/market";
export const UPDATE_MARKET = "/market";
// Billing
export const GET_BILLING = "/billing";
// Feed
export const GET_FEEDS = "/feeds";
export const POST_FEED = "/feed";
export const DELETE_FEED = "/feed";
export const GET_FEED_INFO = "/feed";
export const POST_FEED_FOR_PREVIEW = "/feed/preview";
export const UPDATE_FEED = "/feed";
export const POST_FEED_MOVE_TO_FOLDER = "/feed/move-to-folder";
export const POST_DUPLICATE_FEED = "/feed/duplicate";
export const GET_SOURCE = "/source";
export const GET_FEEDS_CAMPAIGNS = '/feeds/campaigns';
// Folder
export const POST_FOLDER = "/folder";
export const DELETE_FOLDER = "/folder";
export const GET_FOLDER_ROOT = "/folder/root";
export const GET_FOLDER_INFOLDER = "/folder/infolder";
export const POST_FOLDER_MOVE_IN = "/folder/move-in";
export const PUT_FOLDER = '/folder';
// Campaign
export const GET_CAMPAIGNS = "/campaigns";
export const GET_CAMPAIGNS_USERS = "/campaigns/users";
export const GET_ADTYPES = "/campaign/adtypes";
export const POST_CAMPAIGN = "/campaign";
export const DELETE_CAMPAIGN = "/campaign";
export const POST_DUPLICATE_CAMPAIGN = "/campaign/duplicate";
export const POST_CAMPAIGN_MOVE_TO_FOLDER = "/campaign/move-to-folder";
export const PUT_CAMPAIGN = "/campaign";
// Campaign - Social
export const GET_FACEBOOK_PROPERTIES = '/facebook-properties';
export const POST_FACEBOOK_PROPERTIES = '/facebook-properties';
export const PUT_FACEBOOK_PROPERTIES = '/facebook-properties';
export const DELETE_FACEBOOK_PROPERTIES = '/facebook-properties'
export const POST_FACEBOOK_USER_AUTH = '/facebook-user-auth';
export const POST_FACEBOOK_BUSINESS_AUTH = '/facebook-business-auth';
export const GET_FACEBOOK_EXCHANGE_TOKEN = '/facebook-exchange-token';
export const POST_FACEBOOK_LIST_BUSINESSES = '/facebook-list-businesses';
export const POST_FACEBOOK_REFRESH_BUSINESSES = '/facebook-refresh-businesses';
export const POST_FACEBOOK_LIST_CATALOGS = '/facebook-list-catalogs';
export const POST_FACEBOOK_REFRESH_CATALOGS = '/facebook-refresh-catalogs';
export const POST_FACEBOOK_LIST_FEEDS = '/facebook-list-feeds';
export const POST_FACEBOOK_REFRESH_FEEDS = '/facebook-refresh-feeds';
export const POST_FACEBOOK_CREATE_CATALOG = '/facebook-create-catalog';
// Version
export const GET_VERSIONS = "/versions";
export const POST_VERSION = "/version";
export const POST_DUPLICATE_VERSION = "/version/duplicate";
export const UPDATE_VERSION = "/version";
export const POST_VERSION_CONNECT_FEED = "/version/connect-feed";
// Creative
export const GET_CREATIVES = "/creatives";
export const POST_CREATIVE = "/creative";
export const UPDATE_CREATIVE = "/creative";
export const POST_CREATIVES_APPROVE = "/creatives/approve";
export const POST_CREATIVE_DUPLICATE = "/creative/duplicate";
export const DELETE_CREATIVE = "/creative";
export const POST_CREATIVE_SIZE = '/creative/size';
// Template Category
export const GET_CATEGORIES = '/categories';
export const POST_CATEGORY = '/category';
export const PUT_CATEGORY = '/category';
export const DELETE_CATEGORY = '/category';
// Template
export const GET_TEMPLATE = "/template";
export const POST_TEMPLATE = "/template";
export const GET_TEMPLATE_CREATIVES = "/template/creatives";
export const POST_TEMPLATE_CREATIVES = "/template/creatives";
// Dynamic Text
export const GET_DYNAMICTEXT = "/dynamictext";
export const POST_DYNAMICTEXT = "/dynamictext";
export const PUT_DYNAMICTEXT = "/dynamictext";
// Comment
export const GET_COMMENTS = "/comments";
export const POST_COMMENT = "/comment";
// Upload
export const POST_UPLOAD_IMAGE = "/upload";
export const POST_UPLOAD_LOGO = "/upload/logo";
export const GET_UPLOAD_LIMITS = "/upload/limits";
export const POST_UPLOAD_ASSET = "/upload/asset";
// Publish
export const GET_PUBLISH_LIST = "/publish/list";
export const POST_PUBLISH = '/publish';
export const GET_PUBLISH_TAG = '/publishTag';
export const POST_PUBLISHES_CREATIVE = '/publishes/creative';
// Publish DCM
export const POST_DCMAUTH = '/dcm/dcmauth';
export const GET_DCMAUTH = '/dcm/dcmauth';
export const GET_LIST_PROFILES = '/dcm/list-profiles';
export const GET_LIST_DCM_ADVERTISERS = '/dcm/list-advertisers';
export const GET_LIST_DCM_CAMPAIGNS = '/dcm/list-campaigns';
export const POST_SAVE_DCM_PROFILE = '/dcm/save-profile'
export const POST_REFRESH_DCM_ADVERTISERS = '/dcm/refresh-advertisers';
export const POST_REFRESH_DCM_CAMPAIGNS = '/dcm/refresh-campaigns';
// Publish Adform
export const POST_ADFORM_SAVE_CREDENTIALS = '/adform/save-credentials';
export const GET_ADFORM_CREDENTIALS = '/adform/adform-credentials';
export const GET_ADFROM_LIST_ADVERTISERS = '/adform/list-advertisers';
export const POST_ADFORM_REFRESH_ADVERTISERS = '/adform/refresh-advertisers';
export const GET_ADFORM_LIST_CAMPAIGNS = '/adform/list-campaigns';
export const POST_ADFORM_REFRESH_CAMPAIGNS = '/adform/refresh-campaigns';
// Showcase
export const GET_SHOWCASE = '/showcase';
export const POST_SHOWCASE = '/showcase';
export const POST_SHOWCASE_SHARE = '/showcase/share';
export const PUT_SHOWCASE = '/showcase';
// Activity
export const GET_ACTIVITIES = "/activities";
export const POST_ACTIVITIES = "/activities";
// Studio - Fonts
export const GET_FONTS = '';
export const GET_FONT_CSS = '/css';
export const POST_FONTS_UPLOAD = '/upload';
export const POST_FONTS = '';
export const PUT_FONTS = '';
export const GET_FONTS_LIST = "/list";
// Analytics
// Campaign Ids
export const GET_CAMPAIGNIDS_CLIENT = '/campaignids/client';
export const GET_CAMPAIGNIDS_BRAND = '/campaignids/brand';
export const GET_CAMPAIGNIDS_MARKET = '/campaignids/market';
// Analytics
export const POST_IMPRESSION = '/impression';
export const POST_IMPRESSIONDETAIL = '/impressiondetail';
export const POST_CLICK = '/click';
export const POST_CLICKDETAIL = '/clickdetail';
export const POST_HEATMAP = '/heatmap';
export const GET_VERSION = '/versions';
export const GET_CREATIVE = '/creatives';
// Notifications
export const GET_NOTIFICATIONS = '/notifications';
export const POST_READ_NOTIFICATIONS = '/read-notifications';